import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HomeService } from 'app/home/home.service';

@Injectable()
export class MapsService extends HomeService {

  public msg: any;

  constructor(public http: HttpClient) {
    super(http, 'report/map');
    this.loadMessage();
  }

  private loadMessage() {
    this.msg = {
      '400.00': 'Dados inválidos.'
    }
  }
}
